export const HOSTURL = "https://api.nbcfonline.com";
//export const HOSTURL = "http://localhost:5000";
export const BOOTH_AUTH_API = "/booth/user/authenticate/";
export const BOOTH_USER_API = HOSTURL + "/booth/user/";
export const USER_API = HOSTURL + "/user/";
export const TOKEN_API = HOSTURL + "/tokens";
